import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";


import Home from "./components/payment/home";
// import Pay from "./components/payment/Pay";
import PhysicianInforation from "./components/payment/PhysicianInforation";
import PatientActivity from "./components/payment/PatientActivity";
import InitialProcessing from "./components/payment/InitialProcessing";
import PaymentInformation from "./components/payment/PaymentInformation";
import InfectiousDisease from "./components/payment/InfectiousDisease";
import ClientConsent from "./components/payment/ClientConsent";
import ForgotPassword from "./components/payment/ForgotPassword";
import StemCellRequest from "./components/payment/StemCellRequest";
import ActBankingStrorage from "./components/payment/ActBankingStrorage";
import MemberAgreement from "./components/payment/MemberAgreement";
import Store from "./components/payment/Store";
import ACTResources from "./components/payment/Resources";




// import "./App.css";



class App extends Component {
  /*<Navbar />*/
  render() {
    return (
      <Provider  store={store}>
        <Router>
          <div className="App">

            <Route>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/physician-information" component={PhysicianInforation} />
                <Route exact path="/patient-activity" component={PatientActivity} />     
                <Route exact path="/initial-processing" component={InitialProcessing} />                    
                <Route exact path="/payment-information" component={PaymentInformation} />     
                <Route exact path="/infectious-disease" component={InfectiousDisease} />     
                <Route exact path="/client-consent" component={ClientConsent} />     
                <Route exact path="/forgot-password" component={ForgotPassword} />     
                <Route exact path="/stem-cell-request" component={StemCellRequest} />     
                <Route exact path="/stem-cell-request/:id" component={StemCellRequest} />     
                <Route exact path="/ACT-banking-storage-plans" component={ActBankingStrorage} />     
                <Route exact path="/physician-agreement" component={MemberAgreement} />     
                <Route exact path="/store" component={Store} />     
                <Route exact path="/resources" component={ACTResources} />     

              </Switch>
            </Route>        

          </div>
        </Router>
      </Provider>
    );
  }
}
export default App;
